<div class="voucher-tile card-interactive" [tabIndex]="0">
	<div class="voucher-tile-image-container">
		<img class="voucher-tile-image" [src]="logoUrl()" [alt]="getName()" />
	</div>
	<div class="voucher-tile-content">
		<ng-content></ng-content>
	</div>
</div>
